import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const landingPageSelectItem = objectOf({
  id: string,
  value: string,
});

export const isEngagementLandingPagesAppGroupIdSelectResult = objectOf({
  results: arrayOf(landingPageSelectItem),
});
